import {Result} from '../../resultModel'
import {
  SBPQUESTION_GETBYID_URL,
  SBPQUESTION_SAVE_POSTURL
} from '../../endpoints'
import {RequestManager} from '../../RequestManager'
import { GetSBPQuestionsByIdOutput } from './models/getSBPQuestionsModels'
import { SaveSBPQuestionsInput } from './models/createSBPQuestionsModels'

export const getSBPQuestionsById = async (id: number) => {
    const requestManager = new RequestManager()
  
    var res: Result<GetSBPQuestionsByIdOutput> = {success: false, message: 'Hata', data: null}
    ////debugger
    return requestManager
      .get<Result<GetSBPQuestionsByIdOutput>>(SBPQUESTION_GETBYID_URL(id))
      .then((response) => {
        ////debugger
        res = response
        return res
      })
      .catch((error) => {
        res.message = error.message
        return res
      })
  }

  export const saveSBPQuestions = async (input: SaveSBPQuestionsInput) => {
    const requestManager = new RequestManager()
  
    var res: Result<string> = {success: false, message: 'Hata', data: null}
    ////debugger
    return requestManager
      .post<Result<string>>(SBPQUESTION_SAVE_POSTURL, input)
      .then((response) => {
        ////debugger
        res = response
        return res
      })
      .catch((error) => {
        res.message = error.message
        return res
      })
  }